module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"employerRegistration":"Employer registration"}}')
  delete Component.options._Ctor
}
